module.exports = __webpack_public_path__ + "img/pic2.624ae3f7.png";